import type { AxiosInstance } from 'axios';
import type { Stores } from '@lotta/shared/types-lottery-schemas';
import type { IStoresFetcher } from './interfaces/stores';

export class StoresFetcher implements IStoresFetcher {
  constructor(private readonly axiosInstance: AxiosInstance) {}

  async getStores(
    retailUnit: string,
    language: string
  ): Promise<{ id: string; displayName: string }[]> {
    const stores: Stores = [];
    const response = await this.axiosInstance.get<Stores>(
      `https://www.ikea.com/${retailUnit.toLowerCase()}/${language.toLowerCase()}/meta-data/informera/stores-suggested-detailed.json`
    );

    response.data.map((store) => {
      stores.push({
        id: store.id,
        displayName: store.displayName,
      });
    });

    return stores;
  }
}
